import { ClientSideMenu } from '~/features/ClientSideMenu';
import { CreateStressAssessment } from '~/features/CreateStressAssessment';
import styles from './styles.module.scss';

export const Screen: React.FC = () => (
  <div className={styles.Screen}>
    <ClientSideMenu />
    <CreateStressAssessment />
  </div>
);
